import React, { useEffect, useState } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";

const GrnInspection = () => {
    useAuthRedirect();
const [data, setData] = useState([]);
const [filteredData, setFilteredData] = useState([]);
const [searchTerm, setSearchTerm] = useState("");
const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage] = useState(10);
const [loading, setLoading] = useState(false);

const canView  = hasPermission("Bill Passing Menu - HO", "view");
const canEntry = hasPermission("Bill Passing Menu - HO", "entry");

useEffect(() => {
    fetchData();
}, []);

const fetchData = async () => {
    setLoading(true);
    try {
    const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/billHo_listing`);
    setData(response.data.billHOlist);
    setFilteredData(response.data.billHOlist);
    } catch (error) {
    console.error("Error fetching billHOlist:", error);
    } finally {
    setLoading(false);
    }
};

const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (term === "") {
        setFilteredData(data);
        return;
    }

    const filtered = data.filter((item) => 
        String(item.grnHeader_Number || "").toLowerCase().includes(term) || 
        String(item.grnHeader_suppliercode || "").toLowerCase().includes(term)
    );

    setFilteredData(filtered);
};

if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

// Pagination
const paginate = (pageNumber) => setCurrentPage(pageNumber);
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

return (
    <div id="admin-container">
    <InventoryNav />
    <div className="content-right">
        <section>
        
        
          <div className="back-div">
                        <h2 className="add-txt">Bill Passing G R N</h2>
                        <Link to='/inventory/billpassingmenu'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                        </div>
        <Time />
        </section>

        
                {/* Add New Button */}
                {canEntry && (
                <div className="add-new-container">
                  <Link to={`/inventory/billpassingGrnViewSingle`}>
                    <button className="add-new-btn">
                      <i className="fa-solid fa-plus"></i> Add New
                    </button>
                  </Link>
                </div>
                )}
        


        {/* Search Filter */}
        <div className="search-filter">
        <p>Search: </p>
        <input
            type="text"
            placeholder="Search by GRN No"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
        />
        </div>

        {/* Table */}
        <div className="content-table">
        <table>
            <thead>
            <tr>
                <th>S.No</th>
                <th>GRN No</th>
                <th>GRN Date</th>
                <th>Branch</th>
                <th>Supplier Code</th>
                <th>Supplier Name</th>
                <th>Amount</th>
                <th>View</th>
            </tr>
            </thead>
            <tbody>
            {loading ? (
                <tr>
                <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
            ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{item.grnHeader_Number}</td>
                    <td>{new Date(item.grnHeader_Date).toLocaleDateString()}</td>
                    <td>{item.branchcode}</td>
                    <td>{item.grnHeader_suppliercode}</td>
                    <td>{item.SupplierMaster_Name}</td>
                    <td>{item.grnHeader_totalValue.toFixed(2)}</td>
                     <td><Link to={`/inventory/billpassingview/${item.grnHeader_Number}`}>View</Link></td>
                </tr>
                ))
            ) : (
                <tr>
                <td colSpan="6">No Data Available</td>
                </tr>
            )}
            </tbody>
        </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
        <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
        </button>

        {/* Always show first page */}
        <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
        </button>

        {/* Show up to 3 pages dynamically */}
        {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
            const pageNumber = currentPage + index;
            if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                </button>
                );
            }
            return null;
            })
        }

        {/* Next button */}
        <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
        </button>
        </div>
    </div>
    </div>
);
};

export default GrnInspection;
